import React from 'react'
import styled from 'styled-components'
import { TextArea } from 'sutra/components'
import { gray } from 'sutra/tokens/colors'
import { spacing } from 'sutra/tokens/spacing'
import { typography } from 'sutra/tokens/typography'

export interface ReportsAgentFieldsProps {
  prompt: string
  onPromptChange: (value: string) => void
}

/** Reports Agent's Instructions body — just the prompt. Moved out of the
 * deleted GeneralAgentConfigStep; name/submit now live in the shared shell.
 * Reports has no filters, sensitivity, or notifications (see the concept
 * matrix) — the shortest of the three per-type fields components. */
export const ReportsAgentFields: React.FC<ReportsAgentFieldsProps> = ({
  prompt,
  onPromptChange,
}) => (
  <Field>
    <Label htmlFor="reports-agent-prompt">What should this agent do?</Label>
    <TextArea
      id="reports-agent-prompt"
      value={prompt}
      onChange={(e) => onPromptChange(e.target.value)}
      placeholder="Describe the analysis you want, and be specific — the agent runs this as written and cannot ask you to clarify. Paste a full prompt template, or spell out the question, the time window, and what a useful answer looks like."
      rows={8}
    />
  </Field>
)

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]}px;
`

const Label = styled.label`
  font-family: ${typography.fontFamily};
  font-size: 13px;
  font-weight: ${typography.weights.semibold};
  color: ${gray[900]};
`
